var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quantity-selector", attrs: { role: "group" } },
    [
      _c(
        "button",
        {
          attrs: { type: "button", disabled: !_vm.canDecrement },
          on: {
            click: function($event) {
              return _vm.updateQuantity(-1)
            }
          }
        },
        [_vm._v("\n    -\n  ")]
      ),
      _vm._v(" "),
      _c("input", {
        attrs: { disabled: "", type: "text" },
        domProps: { value: _vm.quantity }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { type: "button", disabled: !_vm.canIncrement },
          on: {
            click: function($event) {
              return _vm.updateQuantity(1)
            }
          }
        },
        [_vm._v("\n    +\n  ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }